import { render, staticRenderFns } from "./editable-task-name.vue?vue&type=template&id=52c2c314&scoped=true&"
import script from "./editable-task-name.vue?vue&type=script&lang=js&"
export * from "./editable-task-name.vue?vue&type=script&lang=js&"
import style0 from "./editable-task-name.vue?vue&type=style&index=0&id=52c2c314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2c314",
  null
  
)

export default component.exports